<template>
    <Header
        :page-title="title"
    ></Header>
    <div class="page-content">
        <div class="town-street-center">
            <div class="town-street-center-block" v-for="(item, i) in areaList" :key="i" @click="handleClick(item.townId, item.name)">
                <img :src="item.icon">
                <p>{{ item.name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import { useRouter } from "vue-router"
import { message } from 'ant-design-vue'
const banner = require('@/assets/img/page_banner_1.png')
const shx = require('@/assets/img/shanghe.png')
const bq = require('@/assets/img/baiqiao.png')
const hm = require('@/assets/img/hanmiao.png')
const hr = require('@/assets/img/huairen.png')
const jz = require('@/assets/img/jiazhuang.png')
const lss = require('@/assets/img/longsangsi.png')
const shz = require('@/assets/img/shahe.png')
const sj = require('@/assets/img/sunji.png')
const xs = require('@/assets/img/xushang.png')
const yhm = require('@/assets/img/yuhuangmiao.png')
const yx = require('@/assets/img/yinxiang.png')
const zf = require('@/assets/img/zhangfang.png')
const zl = require('@/assets/img/zhenglu.png')
import {onMounted} from 'vue'
// const jjkfq = require('@/assets/img/kaifaqu.png')
import {verifyApi} from "@/api/login"
export default {
    name: "InformationService",
    setup() {
        const router = useRouter()
        const title = {
            cn: '镇街中心',
            en: 'TOWN STREET CENTER',
            hasSearch: false,
            titleStyle: false,
            banner
        }
        const handleClick = (townId, name) => {
            console.log(townId, name)
            router.push({ name: 'TownHome', query: {townId: townId, name: name}})
            // if (townId === '5172' || townId === '5167') {
            //     router.push({ name: 'TownHome', query: {townId: townId, name: name}})
            // } else {
            //     message.warning('功能对接中……')
            // }
        }
        const areaList = [
            {name: '张坊镇', icon: zf, townId: '5172'},
            {name: '玉皇庙镇', icon: yhm, townId: '5167'},
            {name: '怀仁镇', icon: hr, townId: '5163'},
            {name: '许商街道', icon: xs, townId: '6048'},
            {name: '殷巷镇', icon: yx, townId: '5162'},
            {name: '龙桑寺镇', icon: lss, townId: '5164'},
            {name: '郑路镇', icon: zl, townId: '5165'},
            {name: '贾庄镇', icon: jz, townId: '5166'},
            {name: '白桥镇', icon: bq, townId: '5168'},
            {name: '孙集镇', icon: sj, townId: '5169'},
            {name: '韩庙镇', icon: hm, townId: '5170'},
            {name: '沙河镇', icon: shz, townId: '5171'},
        ]
        onMounted(() => {
            verifyApi()
        })
        return {
            title,
            areaList,
            handleClick
        }
    },
    components: {
        Header,
    }
}
</script>

<style scoped lang="stylus">
.town-street-center {
    width 100%
    height 100%
    display flex
    flex-wrap wrap
    justify-content space-evenly
    padding 0 20px
    .town-street-center-block {
        width 68px
        text-align center
        cursor pointer
        user-select none
        margin-bottom 10px
    }
    .town-street-center-block p {
        color #6A6A6A
        font-size 14px
    }
    .town-street-center-block img {
        width 68px
        height 68px
    }
}
</style>